import { render, staticRenderFns } from "./FooterHomeThree.vue?vue&type=template&id=d56e71e6"
import script from "./FooterHomeThree.vue?vue&type=script&lang=js"
export * from "./FooterHomeThree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports